// extracted by mini-css-extract-plugin
export default {"wrapper":"LineWrap_wrapper__5nQlo","title":"LineWrap_title__tFxkD","line":"LineWrap_line__+ZNkL"};